/*
 * Free Gift (yastık + yorgan)
 * -----------------------------------------------------------------------------
 * "Yatak alana hediye" mekanizması.
 *
 * Uygunluk (hangi yatak, kaç yastık, hangi boy yorgan) TAMAMEN sunucu tarafında (Liquid) hesaplanır
 * ve bu bileşene `data-gifts` (JSON: [{id, required, inCart}]) olarak verilir. Bu bileşen yalnızca
 * sepetteki hediye adetlerini hedefe eşitler (ekler / çıkarır). Böylece uygunluk mantığı
 * tarayıcıda taklit edilmez; kırılgan istemci tarafı kural yoktur.
 *
 * NOT: İstemci tarafı her zaman atlatılabilir (doğrudan /cart/add.js). Ödeme servisi
 * (özel ödeme sayfası) hediye adedini ayrıca sunucuda doğrular.
 */
class FreeGiftPillow extends HTMLElement {
  constructor() {
    super();

    try {
      this.gifts = JSON.parse(this.getAttribute('data-gifts') || '[]');
    } catch (e) {
      this.gifts = [];
    }
  }

  connectedCallback() {
    // Kullanıcı adedi hızlı değiştirirken sepet birkaç kez yeniden çizilir; her çizimde eski hedefe
    // göre ekleme/çıkarma yapılırsa hediyeler gelip gider. Bu yüzden kısa süre bekler, yalnızca
    // en son çizilen eleman çalışır ve hedefi sepetin GÜNCEL halinden tekrar okur.
    clearTimeout(FreeGiftPillow.timer);
    FreeGiftPillow.timer = setTimeout(() => this.reconcile(), 500);
  }

  async reconcile() {
    if (!this.isConnected || FreeGiftPillow.syncing) return;

    let gifts = this.gifts;
    try {
      const section = this.closest('.shopify-section');
      const sectionId = section && section.id.replace('shopify-section-', '');
      if (sectionId) {
        const html = await (await fetch(`${window.location.pathname}?section_id=${sectionId}`)).text();
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('free-gift-pillow');
        gifts = fresh ? JSON.parse(fresh.getAttribute('data-gifts') || '[]') : [];
      }
    } catch (e) {
      return;
    }
    if (!this.isConnected || FreeGiftPillow.syncing) return;

    const updates = {};
    gifts.forEach((gift) => {
      const id = parseInt(gift.id);
      if (!id) return;
      const required = parseInt(gift.required) || 0;
      const inCart = parseInt(gift.inCart) || 0;
      if (required !== inCart) updates[id] = required;
    });
    if (Object.keys(updates).length === 0) return;

    FreeGiftPillow.syncing = true;
    this.sync(updates);
  }

  sync(updates) {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const body = JSON.stringify({
      updates,
      sections: sectionsToBundle
    });

    fetch(`${theme.routes.cart_update_url}`, { ...theme.utils.fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        // Ekleme hatasi (or. gecersiz/silinmis varyant) -> cart.item_count yok.
        // Bozuk cart objesini yayinlarsak sepet sayaci "undefined" olur; yayinlama.
        if (!parsedState || parsedState.status || parsedState.item_count === undefined) {
          console.log('[free-gift] hediye eklenemedi', parsedState);
          return;
        }
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift-pillow', cart: parsedState });
      })
      .catch((error) => {
        console.log('[free-gift]', error);
      })
      .finally(() => {
        FreeGiftPillow.syncing = false;
      });
  }
}
FreeGiftPillow.syncing = false;
customElements.define('free-gift-pillow', FreeGiftPillow);
